// Generated by Melange

import * as Buhta_models__Atd from "./Atd.js";
import * as Buhta_models__Protocol_cms_mel from "./generated/Protocol_cms_mel.js";

function decode(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_blogTags, param);
}

const BlogTags = {
  decode: decode,
  $$default: /* [] */ 0
};

function decode$1(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_blogPosts, param);
}

const $$default = {
  total: 0,
  results: /* [] */ 0
};

const BlogPosts = {
  decode: decode$1,
  $$default: $$default
};

function decode$2(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_blogFavorites, param);
}

const BlogFavorites = {
  decode: decode$2
};

function decode$3(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_blogSearch, param);
}

const BlogSearch = {
  decode: decode$3
};

const $$default$1 = {
  id: "",
  tags: /* [] */ 0,
  readingTime: 0,
  title: "",
  imgUrl: "/",
  author: "",
  createdAtStr: "",
  createdAtLongStr: "",
  render: "",
  description: ""
};

function decode$4(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_wikiPage, param);
}

const WikiPage = {
  $$default: $$default$1,
  decode: decode$4
};

function decode$5(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_libraryTags, param);
}

const LibraryTags = {
  decode: decode$5,
  $$default: /* [] */ 0
};

function decode$6(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_libraryFavorites, param);
}

const LibraryFavorites = {
  decode: decode$6
};

function decode$7(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_libraryArticles, param);
}

const $$default$2 = {
  total: 0,
  results: /* [] */ 0
};

const LibraryArticles = {
  decode: decode$7,
  $$default: $$default$2
};

function decode$8(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_librarySearch, param);
}

const LibrarySearch = {
  decode: decode$8
};

function decode$9(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_aboutPage, param);
}

const $$default$3 = {
  title: "",
  paragraph: "",
  subtext: "",
  title_2: "",
  paragraph_2: "",
  list_title: "",
  list_item_1: "",
  list_item_2: "",
  list_item_3: "",
  list_item_4: "",
  list_item_5: "",
  list_item_6: "",
  list_item_7: "",
  list_item_subtext_7: "",
  list_title_2: "",
  list_item_2_1: "",
  list_item_2_2: "",
  list_item_2_3: "",
  list_item_2_4: "",
  list_item_2_5: "",
  list_item_2_6: "",
  list_item_2_7: "",
  list_item_2_8: "",
  list_item_2_9: "",
  how_title: "",
  how_item_1: "",
  how_item_2: "",
  how_item_3: "",
  who_title: "",
  who_subtitle: "",
  media_title: "",
  media_text_1: "",
  media_link_1: "",
  media_name_1: "",
  media_text_2: "",
  media_link_2: "",
  media_name_2: "",
  media_text_3: "",
  media_link_3: "",
  media_name_3: "",
  media_text_4: "",
  media_link_4: "",
  media_name_4: "",
  coverage_title: "",
  coverage_workers: "",
  coverage_clients: "",
  coverage_solutions: "",
  pricing_title: "",
  pricing_subtitle: "",
  question_1: "",
  answer_1: "",
  question_2: "",
  answer_2: "",
  question_3: "",
  answer_3: ""
};

const AboutPage = {
  decode: decode$9,
  $$default: $$default$3
};

function decode$10(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_outsourcings, param);
}

const Outsourcing = {
  decode: decode$10
};

function decode$11(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_requisites, param);
}

const Requisites_default = {
  name: "",
  bin: undefined,
  bank: "",
  iik: undefined,
  bik: undefined,
  address: "",
  phone: "",
  inn: undefined,
  okpo: undefined,
  account: undefined,
  oked: undefined,
  mfo: undefined,
  kbe: undefined,
  country: "",
  license: undefined,
  privacy: undefined,
  email: "",
  site: ""
};

const Requisites = {
  decode: decode$11,
  $$default: Requisites_default
};

function decode$12(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_faqs, param);
}

const FAQ = {
  decode: decode$12
};

function decode$13(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_homePage, param);
}

const $$default$4 = {
  title: "",
  subtitle: "",
  feature_heading_1: "",
  feature_text_1: "",
  feature_heading_2: "",
  feature_text_2: "",
  carousel_title: "",
  carousel_feature_1: "",
  carousel_feature_2: "",
  carousel_feature_3: "",
  carousel_item_title_1: "",
  carousel_item_text_1: "",
  carousel_item_subtext_1: "",
  carousel_item_title_2: "",
  carousel_item_text_2: "",
  carousel_item_subtext_2: "",
  carousel_item_title_3: "",
  carousel_item_text_3: "",
  carousel_item_subtext_3: "",
  client_title: "",
  client_subtitle: "",
  client_quote_1: "",
  client_name_1: "",
  client_quote_2: "",
  client_name_2: "",
  business_count: "",
  outsourcing_title: "",
  outsourcing_text: "",
  carousel_client_quote_1: "",
  carousel_client_name_1: "",
  carousel_client_quote_2: "",
  carousel_client_name_2: "",
  carousel_client_quote_3: "",
  carousel_client_name_3: "",
  last_feature_title_1: "",
  last_feature_text_1: "",
  last_feature_title_2: "",
  last_feature_text_2: ""
};

const HomePage = {
  decode: decode$13,
  $$default: $$default$4
};

function decode$14(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_jobCategories, param);
}

const JobCategories = {
  decode: decode$14
};

function decode$15(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_mainMenus, param);
}

const MainMenu = {
  decode: decode$15
};

function decode$16(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_pricingPage, param);
}

const $$default$5 = {
  title: "",
  subtitle: "",
  card_title: "",
  card_text_1: "",
  card_text_2: "",
  from_turnover: "",
  card_title_2: "",
  card_subtitle_2: ""
};

const PricingPage = {
  decode: decode$16,
  $$default: $$default$5
};

function decode$17(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_pricingCategories, param);
}

const PricingCategories = {
  decode: decode$17
};

function decode$18(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_cms_mel.read_content, param);
}

function encode(param) {
  return Buhta_models__Atd.encode(Buhta_models__Protocol_cms_mel.write_content, param);
}

const $$default$6 = {
  pricingCategories: /* [] */ 0,
  outsourcings: /* [] */ 0,
  blogTags: /* [] */ 0,
  blogPosts: $$default,
  blogFavorites: /* [] */ 0,
  blogSearch: /* [] */ 0,
  wikiPage: $$default$1,
  libraryTags: /* [] */ 0,
  libraryFavorites: /* [] */ 0,
  libraryArticles: $$default$2,
  librarySearch: /* [] */ 0,
  aboutPage: $$default$3,
  requisites: /* [] */ 0,
  faqs: /* [] */ 0,
  homePage: $$default$4,
  jobCategories: /* [] */ 0,
  mainMenus: /* [] */ 0,
  pricingPage: $$default$5
};

const Content = {
  decode: decode$18,
  encode: encode,
  $$default: $$default$6
};

function encode$1(param) {
  return Buhta_models__Atd.encode(Buhta_models__Protocol_cms_mel.write_request, param);
}

const $$Request = {
  encode: encode$1
};

export {
  BlogTags,
  BlogPosts,
  BlogFavorites,
  BlogSearch,
  WikiPage,
  LibraryTags,
  LibraryFavorites,
  LibraryArticles,
  LibrarySearch,
  AboutPage,
  Outsourcing,
  Requisites,
  FAQ,
  HomePage,
  JobCategories,
  MainMenu,
  PricingPage,
  PricingCategories,
  Content,
  $$Request,
}
/* Buhta_models__Atd Not a pure module */
